(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accordion-with-images"] && !Shopify.designMode) return;
  try {
    
// PC端手风琴鼠标悬停
document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.accordion-item');
  items.forEach(item => {
    item.addEventListener('mouseenter', () => {
      items.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
    });
  });

  // 初始化 Swiper 手机端
  new Swiper('.accordion-swiper', {
    slidesPerView: 1.3,
    spaceBetween: 15,
    // centeredSlides: true,
    loop: true,
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["activity_section1"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const discountLines = document.querySelectorAll('.discount-line');

  discountLines.forEach(line => {
    line.addEventListener('click', function () {
      const code = this.dataset.code; // 获取折扣码
      if (code) {
        navigator.clipboard.writeText(code).then(() => {
          this.classList.add('copied');

          // 移除提示
          setTimeout(() => {
            this.classList.remove('copied');
          }, 1500);
        });
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-text"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  new Swiper('.slide-show-swiper', {
    slidesPerView: 3,
    loop: true,
    spaceBetween: 15,
   breakpoints: {
        768: {
          slidesPerView: 1.3,
          spaceBetween: 15,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 30,
        },
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
